// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"305":"roadmap","594":"about","721":"tokenomics"}[chunkId] + "." + {"305":"02907cb5","594":"499bd5fb","721":"c7365202"}[chunkId] + ".css";
};